<template>
  <div class="dot-info">
    <div class="dot" :style="{ background: validateColors() }" />
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  name: 'DateTimeStatusColors',
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  methods: {
    validateColors() {
      const dateNow = DateTime.now()
      if (DateTime.fromISO(this.startDate) > dateNow) {
        return getStatusLabel('SCHEDULED').color
      }

      return getStatusLabel('ACTIVE').color
    },
  },
}
</script>

<style lang="scss" scoped>
.dot-info {
  padding: 5px;
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}
</style>
